
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/paragraph-generator",
      function () {
        return require("private-next-pages/tools/paragraph-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/paragraph-generator"])
      });
    }
  